import Api from '@/services/Api'

export default {
  getFilter () {
    return Api().get('/company/filter')
  },
  getById (id) {
    return Api().get('/company/'+ id)
  },
  getPackage (data) {
    return Api().get('/company/'+ data.CompanyId +'/package')
  },
  update (data) {
    return Api().put('/company/'+ data.id, data)
  },
  removeMedia(id) {
    return Api().delete('/media/'+ id)
  },

  // Admin
  updateUnifiWalledGarden (site) {
    return Api().post('/company/create/unifi/garden?unifi=5&site=' + site, {site})
  },
  getAll () {
    return Api().get('/company')
  },
  create (data) {
    return Api().post('/company', data)
  },
  edit (data) {
    return Api().put('/company/' + data.id, data)
  },
  delete (data) {
    return Api().delete('/company/' + data.id)
  },


  // Reseller
  getByReseller (id) {
    return Api().get('/reseller/' + id + '/companies')
  },
  createNew (data) {
    return Api().post('/reseller/' + data.ResellerId + '/company/new?unifi=5', data)
  },
  submitExplored (data) {
    return Api().post('/reseller/' + data.ResellerId + '/company/explore', data)
  }
}
